import sleep from '@/helpers/sleep'

const MAX_SEARCH_ATTEMPTS = 5
const SEARCH_INTERVAL = 300
const RENDER_DELAY = 1e3

export async function waitVkPostHeight(rootEl: Element): Promise<number> {
  for (let attempt = 0; attempt <= MAX_SEARCH_ATTEMPTS; attempt++) {
    const iframeEl = rootEl.querySelector('iframe')

    if (iframeEl?.style.height) {
      await sleep(RENDER_DELAY)

      return iframeEl.offsetHeight
    }

    await sleep(SEARCH_INTERVAL)
  }

  return 0
}
